import { find, map, pipe, pluck, propEq, reject } from 'ramda';
import { ILabel } from './LabelsEditor.types';

export const convertLabels = map<string, ILabel>((label) => ({ id: label, label }));

export const reconvertLabels = pluck('id');

export const includesLabel = (label: string, labels: ILabel[]) =>
  pipe<ILabel[], ILabel, boolean>(find<ILabel>(propEq('label', label)), Boolean)(labels);

export const dropLabel = (labelId: string, labels: ILabel[]): ILabel[] => reject<ILabel>(propEq('id', labelId), labels);
